import { render, staticRenderFns } from "./showGroup.vue?vue&type=template&id=39017187"
import script from "./showGroup.vue?vue&type=script&lang=js"
export * from "./showGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports